export class orgtype {
	constructor(
		public Id: string,
		public orgtype: string
	) { }
}